<div class="input-container" #datePicker>
  <div class="date-input form-group input-group mb-0">
    <div class="input input__large input__blue date-value" *ngIf="!editorActive"
         (click)="editorEnabled()" [ngClass]="{'disabled': isDisable}">
      @if (common.isFirefox){
        {{outPickedUpdate}}
      }@else{
        {{outPickedUpdate | date: displayFormat}}
      }
    </div>

    <input type="text" dateMask id="custom-datepicker-input" *ngIf="editorActive"
           class="input input__large input__blue" [(ngModel)]="editorValue"
           (keyup.enter)="editorFinished($event, true)" [disabled]="isDisable"
           (blur)="editorFinished($event)" [placeholder]="placeholder" maxlength="10"
           #editor>
    <!--[textMask]="{mask: dateFieldMask, guide: false, keepCharPositions: true}"-->

    <button id="custom-datepicker-show-date-btn" class="date-icon button ghost__button small__button rounded__button"
            (click)="onClickDateIcon();" [disabled]="isDisable">
      <img [src]="showDate ? '../../../../../assets/images/date-picker.svg' : '../../../../../assets/images/date-picker-light.svg'" alt="...">
    </button>

  </div>
  <span class="color--secondary-red position-absolute" *ngIf="isInterimPopup && showDateError && !outPickedUpdate">Invalid Date</span>

  <div class="calender bg-light" [ngStyle]="{'width.px' : twoMonthMode ? '700' : '350'}" *ngIf="showDate">

    <div class="inner__calender">

      <div class="sCalender" [ngStyle]="{'width' : (twoMonthMode ? '50' : '100') + '%'}">
        <div class="c-titleleft">
          <div class="flex-wrapper" [hidden]="!showPrevIcon(currentDate.getMonth(), currentDate.getFullYear())">
            <button (click)="onClickLeft()" id="custom-datepicker-left-btn" class="button ghost__button">
              <svg-icon name="blue-arrow-left"></svg-icon>
            </button>
          </div>
          <div class="month-title">
            <span class="font-weight-bold" *ngIf="isYearVisible">{{Months[currentDate.getMonth()]}} {{currentDate.getFullYear()}}</span>
            <span class="font-weight-bold" *ngIf="!isYearVisible">{{Months[currentDate.getMonth()]}}</span>
          </div>
          <div class="flex-wrapper">
            <button *ngIf="!twoMonthMode" id="custom-datepicker-right-btn" (click)="onClickRight()" class="button ghost__button">
              <svg-icon name="blue-arrow-right"></svg-icon>
            </button>
          </div>
        </div>

        <div class="flex-row">
          <div class="flex-item"><span>Sun</span></div>
          <div class="flex-item"><span>Mon</span></div>
          <div class="flex-item"><span>Tue</span></div>
          <div class="flex-item"><span>Wed</span></div>
          <div class="flex-item"><span>Thu</span></div>
          <div class="flex-item"><span>Fri</span></div>
          <div class="flex-item"><span>Sat</span></div>
        </div>

        <div class="flex-row">

          <div class="flex-row" style="position: relative;">
            <div *ngFor="let day of daysBefore" class="flex-item"><span></span></div>

            <div (click)="onclickFirstCalendarDay(i);$event.stopPropagation()"
                *ngFor="let day of days; index as i"
                [ngClass]="{'flex-day_active': day.active, 'flex-day_nonselectable':!day.selectable }"
                class="flex-item flex-day">
              <span>{{day.day}}</span>
            </div>

            <div *ngFor="let day of daysAfter" class="flex-item"><span></span></div>

          </div>


        </div>

      </div>
      <div class="sCalender" *ngIf="twoMonthMode">

        <div class="c-titleleft">

          <div class="month-title">
            <span style="font-weight: bolder;" *ngIf="isYearVisible"> {{Months[dateSecondCalendar.getMonth()]}} {{ dateSecondCalendar.getFullYear()}} </span>
            <span style="font-weight: bolder;" *ngIf="!isYearVisible"> {{Months[dateSecondCalendar.getMonth()]}} </span>
          </div>
          <div class="flex-wrapper" style="margin-left: auto;">
            <button (click)="onClickRight()" id="credit-purchase-month=mode-btn" class="button ghost__button"
                    [hidden]="!showNextIcon(dateSecondCalendar.getMonth(), dateSecondCalendar.getFullYear())">
              <svg-icon name="blue-arrow-right"></svg-icon>
            </button>
          </div>
        </div>

        <div class="flex-row">
          <div class="flex-item"><span>Sun</span></div>
          <div class="flex-item"><span>Mon</span></div>
          <div class="flex-item"><span>Tue</span></div>
          <div class="flex-item"><span>Wed</span></div>
          <div class="flex-item"><span>Thu</span></div>
          <div class="flex-item"><span>Fri</span></div>
          <div class="flex-item"><span>Sat</span></div>
        </div>

        <div class="flex-row">
          <div *ngFor="let day of daysBeforeSecondCalendar; " class="flex-item"><span></span></div>

          <div (click)="onclickSecondCalendarDay(i); $event.stopPropagation()"
              *ngFor="let day of daysSecondCalendar; index as i"
              [ngClass]="{'flex-day_active': day.active,'flex-day_nonselectable':!day.selectable  }"
              class="flex-item flex-day">
            <span>{{day.day}}</span>

          </div>

          <div *ngFor="let day of daysAfterSecondCalendar" class="flex-item"><span></span></div>

        </div>

      </div>

    </div>

    <div class="note__section" *ngIf="false">
      {{reportService.getFYEDate('yyyy-M-d', true)}} - {{maxDateString}}
    </div>

  </div>
</div>
